{
  "name": "windy-plugin-fxc-soundings",
  "version": "4.2.1",
  "type": "module",
  "private": true,
  "description": "Alternative sounding graphs with custom features for PG/HG pilots.",
  "author": "Victor Berchet",
  "repository": {
    "type": "git",
    "url": "https://github.com/vicb/flyxc.git",
    "directory": "libs/windy-sounding"
  },
  "bugs": {
    "url": "https://github.com/vicb/flyxc/issues"
  },
  "license": "MIT",
  "sideEffects": [
    "*.css",
    "*.less",
    "*.scss"
  ],
  "scripts": {
    "build:dev": "vite build --mode development",
    "build:prod": "vite build --mode production",
    "build:config": "BUILD_PLUGIN_CONFIG=true pnpm run build:prod",
    "clean": "rm -rf dist",
    "lint": "eslint . --max-warnings=0",
    "lint:fix": "eslint . --fix",
    "format": "prettier --write \"**/*.{ts,tsx,js,jsx,json,css,scss,md}\"",
    "format:check": "prettier --check \"**/*.{ts,tsx,js,jsx,json,css,scss,md}\"",
    "manifest": "node generate-manifest.js dist",
    "preview": "pnpm build:dev --watch & pnpm build:prod --watch & vite preview",
    "upload:prepare": "rm -rf dist && pnpm build:prod && pnpm build:dev && pnpm build:config && pnpm manifest",
    "upload": "./upload.sh"
  },
  "dependencies": {
    "@reduxjs/toolkit": "catalog:default",
    "@sveltejs/vite-plugin-svelte": "^7.2.0",
    "date-fns": "catalog:default",
    "geojson": "^0.5.0",
    "preact": "^10.29.7",
    "react-redux": "^9.3.0",
    "jsonc-eslint-parser": "catalog:default",
    "svelte": "^5.56.7"
  },
  "devDependencies": {
    "@babel/core": "^7.29.7",
    "@babel/preset-env": "^7.29.7",
    "@babel/preset-typescript": "^7.29.7",
    "@preact/preset-vite": "catalog:",
    "@types/geojson": "^7946.0.15",
    "svelte-check": "^4.7.3",
    "vite": "catalog:default"
  }
}
